import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Core components
import Link from 'components/core/Link';
import Tooltip from 'components/core/Tooltip';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import { fullDesc } from 'models/distribution';
// Custom
import { distributionDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'distributions/navigation';

const { pAdmin } = permissions;

const DistributionTooltipContent = ({ distribution }) => (
  <div>
    <div className="row m-0">
      <div className="w-100 text-center">{fullDesc(distribution)}</div>
    </div>
    <OnlyWith
      permissions={{
        needed: pAdmin,
      }}
    >
      <div className="pt-2">
        <div className="box-divider-light m-0" />
        <div className="row m-0 pt-2">
          <div className="w-100 text-center">
            <LocalizedMessage id="tooltip.clickToAccess" values={{ resource: 'distribution' }} />
          </div>
        </div>
      </div>
    </OnlyWith>
  </div>
);

DistributionTooltipContent.propTypes = {
  distribution: distributionDataShape.isRequired,
};

const DistributionLink = ({ distribution }) => (
  <div className="d-flex align-items-center">
    <Tooltip
      content={<DistributionTooltipContent distribution={distribution} />}
      inheritStyle={false}
      className="text-truncate"
    >
      <OnlyWith
        permissions={{
          needed: pAdmin,
        }}
        alternativeComponent={<span>{fullDesc(distribution)}</span>}
      >
        <Link path={showPath(distribution.id)}>{fullDesc(distribution)}</Link>
      </OnlyWith>
    </Tooltip>
  </div>
);

DistributionLink.propTypes = {
  distribution: distributionDataShape.isRequired,
};

module.exports = DistributionLink;



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/assets/main/DistributionLink.js